import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInformationVideos from '@appStore/learning/reducers/information-videos.reducer';
import * as fromRoot from '../../../reducers';

export interface LearningState {
  informationVideos: fromInformationVideos.State;
}

export interface State extends fromRoot.State {
  learning: LearningState;
}

export const reducers: ActionReducerMap<LearningState> = {
    informationVideos: fromInformationVideos.reducer
};

export const getState = createFeatureSelector<LearningState>('learning');

export const getInformationVideosState = createSelector(
  getState,
  (state: LearningState) => state.informationVideos
);

// InformationVideos

export const getAllInformationVideos = createSelector(
    getInformationVideosState,
    fromInformationVideos.getAll
);

export const getInformationVideosLoaded = createSelector(
    getInformationVideosState,
    fromInformationVideos.getLoaded
);

export const getnformationVideosLoading = createSelector(
    getInformationVideosState,
  fromInformationVideos.getLoading
);







